/* Shaima Ahli custom theme JS */
(function () {
  "use strict";

  /* ---- Sticky / transparent header on scroll (homepage only) ---- */
  var header = document.querySelector(".header");
  var isHome = document.body.classList.contains("template-index");
  if (header && isHome) {
    var onScroll = function () {
      if (window.scrollY > 80) header.classList.add("is-scrolled");
      else header.classList.remove("is-scrolled");
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ---- Mobile drawer (event delegation — robust on all devices) ---- */
  function openDrawer() {
    var d = document.querySelector("[data-drawer]"), o = document.querySelector("[data-overlay]");
    if (d) d.classList.add("is-open");
    if (o) o.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }
  function closeDrawer() {
    var d = document.querySelector("[data-drawer]"), o = document.querySelector("[data-overlay]");
    if (d) d.classList.remove("is-open");
    if (o) o.classList.remove("is-open");
    document.body.style.overflow = "";
  }
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-burger]")) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest("[data-drawer-close]")) { e.preventDefault(); closeDrawer(); return; }
    if (e.target.closest("[data-overlay]")) { closeDrawer(); return; }
  });

  /* ---- Hero slideshow ---- */
  var hero = document.querySelector("[data-hero]");
  if (hero) {
    var slides = hero.querySelectorAll(".hero__slide");
    var dots = hero.querySelectorAll(".hero__dots button");
    var i = 0, timer;
    function go(n) {
      slides[i].classList.remove("is-active");
      dots[i] && dots[i].classList.remove("is-active");
      i = (n + slides.length) % slides.length;
      slides[i].classList.add("is-active");
      dots[i] && dots[i].classList.add("is-active");
    }
    function auto() { timer = setInterval(function () { go(i + 1); }, 6000); }
    dots.forEach(function (d, idx) { d.addEventListener("click", function () { clearInterval(timer); go(idx); auto(); }); });
    if (slides.length > 1) auto();
  }

  /* ---- Product gallery thumbs ---- */
  var gallery = document.querySelector("[data-gallery]");
  if (gallery) {
    var mainImg = gallery.querySelector("[data-main-img]");
    gallery.querySelectorAll("[data-thumb]").forEach(function (t) {
      t.addEventListener("click", function () {
        mainImg.src = t.dataset.full;
        gallery.querySelectorAll("[data-thumb]").forEach(function (x) { x.classList.remove("is-active"); });
        t.classList.add("is-active");
      });
    });
  }

  /* ---- Quantity steppers ---- */
  document.querySelectorAll("[data-qty]").forEach(function (q) {
    var input = q.querySelector("input");
    q.querySelector("[data-minus]").addEventListener("click", function () {
      input.value = Math.max(1, parseInt(input.value || "1", 10) - 1);
    });
    q.querySelector("[data-plus]").addEventListener("click", function () {
      input.value = parseInt(input.value || "1", 10) + 1;
    });
  });

  /* ============ Side cart drawer ============ */
  var drawer = document.querySelector("[data-cart-drawer]");
  if (drawer) {
    var body = drawer.querySelector("[data-cart-body]");
    var foot = drawer.querySelector("[data-cart-foot]");

    function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c]; }); }
    function money(cents) { return "Dhs. " + (cents / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    function sized(url, px) { if (!url) return ""; return url + (url.indexOf("?") > -1 ? "&" : "?") + "width=" + px; }

    function setCount(n) {
      document.querySelectorAll("[data-cart-count]").forEach(function (el) {
        el.textContent = n;
        if (n > 0) el.removeAttribute("hidden"); else el.setAttribute("hidden", "");
      });
    }

    function itemHTML(it) {
      var variant = (it.variant_title && it.variant_title !== "Default Title") ? '<div class="cd-item__variant">' + esc(it.variant_title) + "</div>" : "";
      return '<div class="cd-item" data-key="' + esc(it.key) + '">' +
        '<a class="cd-item__img" href="' + esc(it.url) + '"><img src="' + esc(sized(it.image, 160)) + '" alt="' + esc(it.product_title) + '" width="72" height="72"></a>' +
        '<div class="cd-item__info">' +
          '<a class="cd-item__title" href="' + esc(it.url) + '">' + esc(it.product_title) + "</a>" + variant +
          '<div class="cd-item__price">' + money(it.final_price) + " each</div>" +
          '<div class="cd-qty"><button type="button" data-cd-minus aria-label="Decrease">&minus;</button>' +
          '<input type="text" value="' + it.quantity + '" data-cd-qty readonly aria-label="Quantity">' +
          '<button type="button" data-cd-plus aria-label="Increase">+</button></div>' +
        "</div>" +
        '<div class="cd-item__right">' +
          '<button type="button" class="cd-item__remove" data-cd-remove aria-label="Remove"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m6 6 12 12M18 6 6 18"/></svg></button>' +
          '<div class="cd-item__line">' + money(it.final_line_price) + "</div>" +
        "</div>" +
      "</div>";
    }

    function emptyHTML() {
      return '<div class="cd-empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2 3h3l2.4 12.3a1.5 1.5 0 0 0 1.5 1.2h8.7a1.5 1.5 0 0 0 1.5-1.2L22 6H6"/><path d="m4 4 16 16"/></svg>' +
        "<p>No products in the cart.</p>" +
        '<a class="btn" href="/collections/all" data-cart-close>Return to shop</a></div>';
    }

    function render(cart) {
      setCount(cart.item_count);
      if (!cart.item_count) {
        body.innerHTML = emptyHTML();
        foot.hidden = true;
        return;
      }
      body.innerHTML = cart.items.map(itemHTML).join("");
      foot.innerHTML =
        '<div class="cd-subtotal"><span>Subtotal</span><span>' + money(cart.items_subtotal_price) + "</span></div>" +
        '<p class="cd-note">Taxes and shipping calculated at checkout.</p>' +
        '<div class="cd-actions"><a class="btn btn--outline" href="/cart">View cart</a><a class="btn" href="/checkout">Checkout</a></div>';
      foot.hidden = false;
    }

    var AJAX = { "Content-Type": "application/x-www-form-urlencoded", Accept: "application/json", "X-Requested-With": "XMLHttpRequest" };
    function getCart() { return fetch("/cart.js", { headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" } }).then(function (r) { return r.json(); }); }

    function showDrawer() {
      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
    }
    function openCart() {
      body.innerHTML = '<div class="cd-loading">Loading…</div>';
      showDrawer();
      getCart().then(render);
    }
    function closeCart() {
      drawer.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
    }
    function change(key, qty) {
      return fetch("/cart/change.js", {
        method: "POST", headers: AJAX,
        body: new URLSearchParams({ id: key, quantity: qty }).toString()
      }).then(function (r) { return r.json(); }).then(render);
    }

    /* quick add-to-cart from product cards */
    function quickAdd(btn) {
      if (btn.getAttribute("aria-disabled") === "true" || btn.classList.contains("is-loading")) return;
      var vid = btn.getAttribute("data-variant-id");
      if (!vid) return;
      var labelEl = btn.querySelector("[data-qa-label]");
      function setLabel(t) { if (labelEl) labelEl.textContent = t; else btn.textContent = t; }
      var orig = btn.getAttribute("data-label") || (labelEl ? labelEl.textContent : btn.textContent);
      btn.setAttribute("data-label", orig);
      btn.classList.add("is-loading"); btn.disabled = true; setLabel("Adding…");
      fetch("/cart/add.js", { method: "POST", headers: AJAX, body: new URLSearchParams({ id: vid, quantity: 1 }).toString() })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () { return getCart(); })
        .then(function (cart) {
          render(cart);
          btn.classList.remove("is-loading"); btn.classList.add("is-success"); setLabel("Added ✓");
          showDrawer();
          setTimeout(function () { btn.disabled = false; btn.classList.remove("is-success"); setLabel(orig); }, 1800);
        })
        .catch(function () {
          /* fallback: native POST so the browser can clear any bot checkpoint */
          var f = document.createElement("form"); f.method = "POST"; f.action = "/cart/add";
          [["id", vid], ["quantity", "1"]].forEach(function (p) { var i = document.createElement("input"); i.type = "hidden"; i.name = p[0]; i.value = p[1]; f.appendChild(i); });
          document.body.appendChild(f); f.submit();
        });
    }

    /* open cart from any [data-cart-toggle], close from any [data-cart-close] */
    document.addEventListener("click", function (e) {
      var qa = e.target.closest("[data-quick-add]");
      if (qa) { e.preventDefault(); quickAdd(qa); return; }
      var toggle = e.target.closest("[data-cart-toggle]");
      if (toggle) { e.preventDefault(); openCart(); return; }
      if (e.target.closest("[data-cart-close]")) { closeCart(); return; }
      var item = e.target.closest(".cd-item");
      if (item) {
        var key = item.getAttribute("data-key");
        var qtyEl = item.querySelector("[data-cd-qty]");
        var qty = parseInt(qtyEl ? qtyEl.value : "1", 10);
        if (e.target.closest("[data-cd-remove]")) { change(key, 0); return; }
        if (e.target.closest("[data-cd-plus]")) { change(key, qty + 1); return; }
        if (e.target.closest("[data-cd-minus]")) { change(key, Math.max(0, qty - 1)); return; }
      }
    });

    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && drawer.classList.contains("is-open")) closeCart(); });

    /* intercept product add-to-cart forms -> ajax add + open drawer */
    document.addEventListener("submit", function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      var params = new URLSearchParams();
      new FormData(form).forEach(function (v, k) { params.append(k, v); });
      fetch("/cart/add.js", { method: "POST", headers: AJAX, body: params.toString() })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () { return getCart(); })
        .then(function (cart) { render(cart); drawer.classList.add("is-open"); drawer.setAttribute("aria-hidden", "false"); document.body.style.overflow = "hidden"; })
        .catch(function () { form.submit(); })
        .finally(function () { if (btn) btn.disabled = false; });
    });
  }

  /* ============ Search overlay + recently viewed ============ */
  var sOverlay = document.querySelector("[data-search-overlay]");
  if (sOverlay) {
    var sInput = sOverlay.querySelector("[data-search-input]");
    var recentSec = sOverlay.querySelector("[data-recent-sec]");
    var recentGrid = sOverlay.querySelector("[data-recent-grid]");
    var resultsSec = sOverlay.querySelector("[data-results-sec]");
    var resultsGrid = sOverlay.querySelector("[data-results-grid]");
    var suggestSec = sOverlay.querySelector("[data-suggest-sec]");
    var noResults = sOverlay.querySelector("[data-no-results]");
    var RECENT_KEY = "sa_recent";
    function es(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c]; }); }
    function card(p) {
      var img = p.image ? '<img src="' + es(p.image) + '" alt="' + es(p.title) + '" loading="lazy">' : "";
      return '<a class="scard" href="' + es(p.url) + '"><div class="scard__img">' + img + '</div>' +
        '<div class="scard__title">' + es(p.title) + '</div><div class="scard__price">' + es(p.price) + '</div></a>';
    }
    function getRecent() { try { return JSON.parse(localStorage.getItem(RECENT_KEY) || "[]"); } catch (e) { return []; } }
    function renderRecent() {
      var list = getRecent();
      if (!list.length) { recentSec.hidden = true; return; }
      recentGrid.innerHTML = list.slice(0, 8).map(card).join("");
      recentSec.hidden = false;
    }
    /* record current product view */
    var cp = document.querySelector("[data-current-product]");
    if (cp) {
      try {
        var prod = JSON.parse(cp.textContent);
        if (prod && prod.handle) {
          var l = getRecent().filter(function (x) { return x.handle !== prod.handle; });
          l.unshift(prod);
          localStorage.setItem(RECENT_KEY, JSON.stringify(l.slice(0, 12)));
        }
      } catch (e) {}
    }
    function showDefault() { resultsSec.hidden = true; suggestSec.hidden = false; renderRecent(); }
    function showResults() { suggestSec.hidden = true; recentSec.hidden = true; resultsSec.hidden = false; }
    function openSearch() {
      sOverlay.classList.add("is-open"); sOverlay.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      if (sInput) sInput.value = "";
      showDefault();
      setTimeout(function () { sInput && sInput.focus(); }, 60);
    }
    function closeSearch() { sOverlay.classList.remove("is-open"); sOverlay.setAttribute("aria-hidden", "true"); document.body.style.overflow = ""; }
    var st;
    function doSearch(q) {
      fetch("/search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last",
        { headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
          showResults();
          if (!ps.length) { resultsGrid.innerHTML = ""; noResults.hidden = false; return; }
          noResults.hidden = true;
          resultsGrid.innerHTML = ps.map(function (p) {
            return card({ url: p.url, title: p.title, image: p.image || p.featured_image, price: "Dhs. " + p.price });
          }).join("");
        }).catch(function () {});
    }
    sInput && sInput.addEventListener("input", function () {
      var q = sInput.value.trim();
      clearTimeout(st);
      if (!q) { showDefault(); return; }
      st = setTimeout(function () { doSearch(q); }, 250);
    });
    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-search-toggle]")) { e.preventDefault(); openSearch(); return; }
      if (e.target.closest("[data-search-close]")) { closeSearch(); return; }
      if (e.target.closest("[data-clear-recent]")) { localStorage.removeItem(RECENT_KEY); renderRecent(); return; }
      if (e.target === sOverlay) { closeSearch(); return; }
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && sOverlay.classList.contains("is-open")) closeSearch(); });
  }

  /* ============ Sticky add-to-cart bar (product page) ============ */
  var stickyBar = document.querySelector("[data-sticky-atc]");
  var mainAtc = document.querySelector("[data-main-atc]");
  if (stickyBar && mainAtc && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) stickyBar.classList.remove("is-visible");
        else stickyBar.classList.add("is-visible");
      });
    }, { threshold: 0 });
    io.observe(mainAtc);
  }
})();
